<template>
    <div class="bg-zinc-50 border border-zinc-200 p-3">
        <div class="text-zinc-700 font-medium tracking-tight border-b mb-5 pb-2">{{ textType }} Font</div>

        <div class="flex items-center justify-between mb-2">
            <div class="w-28 mr-5 font-light text-sm">Family</div>
            <fonts-dropdown class="grow" :fonts="model.fonts" :current-font="font" @fontChanged="onFontSelected"></fonts-dropdown>
<!--            <fonts-combo-box :fonts="model.fonts" :selected-font="font"></fonts-combo-box>-->
<!--            <select class="w-full border-gray-200 rounded-md py-1" v-model="font.family" @change="onFontSelected">-->
<!--                <option v-for="font in model.fonts" :value="font.family">{{ font.family }}</option>-->
<!--            </select>-->
        </div>

        <div class="flex items-center justify-between mb-2">
            <div class="w-28 mr-5 font-light text-sm">Weight</div>
            <select class="w-full border-gray-200 rounded-md py-1" v-model="font.weight">
                <option v-for="fontWeight in availableWeights" :value="fontWeight">{{ fontWeight }}</option>
            </select>
        </div>

    </div>
</template>

<script>

import FontsComboBox from "../screens/themes/FontsComboBox.vue";
import FontsDropdown from "../screens/themes/FontsDropdown.vue";

export default {
    name: 'FontSelector',
    components: {FontsDropdown, FontsComboBox},
    props: ['font', 'textType'],
    data() {
        return {
            model: webase.model
        }
    },
    mounted() {
        this.injectFont()
    },
    computed: {
        availableWeights() {
            return webase.utils.ui.availableWeights(this.model.fonts, this.font.family)
        }
    },
    methods: {
        onFontSelected() {
            this.injectFont()
            this.resetWeight()
        },
        injectFont() {
            let weights = this.availableWeights.join(';')
            weights = weights.replace('regular', '400')
            webase.utils.ui.injectFont(this.font.family, ':wght@' + weights)
        },
        resetWeight() {
            this.font.weight = 'regular'
        }
    }
}
</script>
